import * as React from 'react';
import { withSiteData } from 'react-static';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import NavLinkComponent from '../../components/Nav/NavLink';
import { Link } from '../../components/Nav/nav.locale';
import { RootState } from '../../RootState';
import { closeNav, closeSubMenu, openSubMenu, NavState } from './navDuck';
import { RootAction } from '../../RootAction';
import { Language } from '../Localization/localizationDuck';

interface StateProps extends NavState {
  language: Language;
}

export interface DispatchProps {
  closeNav: () => void;
  openSubMenu: (subMenuParentName: string | null) => void;
  closeSubMenu: () => void;
}

interface OwnProps {
  item: Link;
}

export interface NavLinkProps extends StateProps, DispatchProps, OwnProps {}

const NavLink: React.SFC<NavLinkProps> = props => {
  const handleToggleSubMenu = (subMenuParentName: string, mobileMenu: boolean) => {
    if (mobileMenu && subMenuParentName === props.openedSubMenu) {
      props.openSubMenu(null);
    } else {
      props.openSubMenu(subMenuParentName);
    }

    return;
  };

  const handleCloseSubMenu = (e: React.FocusEvent<{}>) => {
    if (!e.relatedTarget) {
      props.closeSubMenu();
    }
  };

  return (
    <NavLinkComponent
      isOpened={props.openedSubMenu === props.item.href}
      item={props.item}
      closeMenu={props.closeNav}
      toggleSubMenu={handleToggleSubMenu}
      closeSubMenu={handleCloseSubMenu}
    />
  );
};

const mapStateToProps = (state: RootState): StateProps => ({
  language: state.localization.language,
  isOpened: state.nav.isOpened,
  isScrolled: state.nav.isScrolled,
  openedSubMenu: state.nav.openedSubMenu,
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps => ({
  openSubMenu: (subMenuParentName: string | null) => dispatch(openSubMenu(subMenuParentName)),
  closeSubMenu: () => dispatch(closeSubMenu()),
  closeNav: () => dispatch(closeNav()),
});

export default withSiteData(
  connect<StateProps, DispatchProps, OwnProps, RootState>(
    mapStateToProps,
    mapDispatchToProps,
  )(NavLink),
);



// WEBPACK FOOTER //
// /www/client/src/containers/Nav/NavLink.tsx